import * as React from "react"
import { ThemeProvider } from "./src/contexts/ThemeContext"
import { CartProvider } from '~/contexts/CartContext'
import { AccountProvider } from '~/contexts/AccountContext'
import { checkMobile } from '~/utils/helpers'

const loadScript = (src, async=true) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = src
    script.async = async
    script.onload = resolve
    script.onerror = reject
    document.body.appendChild(script)
  })
}


export const onClientEntry = () => {
  const isMobile = checkMobile()
  const el = document.querySelector("html")
  el.setAttribute('is-m', isMobile.mobile ? 'true' : 'false')
  isMobile.touches ? el.setAttribute('is-t','true') : el.removeAttribute('is-t')

  if (window.location.pathname === '/') {
    setTimeout(() => {document.querySelectorAll('[g]').forEach(x => x.classList.remove('off'))}, 100)
  }

  loadScript('https://vjs.zencdn.net/8.10.0/video.min.js')
  loadScript('https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=Kd4snB')
  loadScript('https://maps.googleapis.com/maps/api/js?libraries=geometry&key=AIzaSyB-8dYf-PhkvjFkvud4rQV36pos-zV5Qhs&callback=Function.prototype')
  
  if (process.env.NODE_ENV === 'production') {
    loadScript('https://js.afterpay.com/afterpay-1.x.js')
  }
  // loadScript('https://hello.zonos.com/shop-duty-tax/hello.js?1691620067456&amp;shop=buck-mason-usa.myshopify.com')

  window.addEventListener('unload', () => {
    if (window.gladly && window.gladly.close) {
      window.gladly.close();
    }
  });
}


export const wrapRootElement = ({ element }) => (
  <ThemeProvider>
    {element}
  </ThemeProvider>
)

export const wrapPageElement = ({ element }) => {
  return (
    <CartProvider>
      <AccountProvider>
        {element}
      </AccountProvider>
    </CartProvider>
  )
}